import { ButtonWorkspaceDropdown } from "@nova/component-btn"
import { Permissions } from "@nova/constants"
import classNames from "classnames"
import { useWorkspacePermissions } from "features/data-management/workspace/useWorkspacePermissions"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { useAppSelector } from "integrations/redux/hooks"
import { useState } from "react"

export const WorkspaceAccessSplitButton = ({
    defaultPermission,
    dropdownSelection,
    accessEntityId,
    setDropdownSelection,
    portalPositioning,
    allowRemoval = true,
    disabled,
}: {
    defaultPermission: Permissions
    dropdownSelection: Permissions
    setDropdownSelection: (permission: Permissions) => void
    accessEntityId: string
    portalPositioning?: {
        portalId: string
        isFixedPositioned?: boolean
        relativeOffset: number
    }
    allowRemoval?: boolean
    disabled?: boolean
}) => {
    const { isAdmin } = useWorkspacePermissions()
    const [permissionMenuOpen, setPermissionMenuOpen] = useState(false)
    const workspaceId = useAppSelector(selectActiveWorkspaceId()) || ""

    const isSettingWorkspacePermissions = accessEntityId === workspaceId

    const dropdownButtons: { label: string; onClick: () => void; className?: string }[] = [
        {
            label: "Viewer",
            onClick: () => setDropdownSelection(Permissions.Viewer),
        },
        {
            label: "Editor",
            onClick: () => setDropdownSelection(Permissions.Editor),
        },
    ]
    if (isAdmin && isSettingWorkspacePermissions) {
        dropdownButtons.push({
            label: "Admin",
            onClick: () => setDropdownSelection(Permissions.Admin),
        })
    }
    if (allowRemoval)
        dropdownButtons.push({
            label: "Remove Access",
            onClick: () => setDropdownSelection(Permissions.None),
            className: "!text-red-500",
        })
    return (
        <ButtonWorkspaceDropdown
            label={
                dropdownSelection === Permissions.None
                    ? "Remove Access"
                    : Permissions[dropdownSelection || defaultPermission]
            }
            menuOpen={permissionMenuOpen}
            setMenuOpen={setPermissionMenuOpen}
            disabled={disabled}
            className={classNames({
                "!text-red-500": dropdownSelection === Permissions.None,
            })}
            widthClass="!w-[8.938rem]"
            dropdownButtons={dropdownButtons}
            portalPositioning={portalPositioning}
        />
    )
}
